$(function() {
  const textareas = $("textarea.js-diagnose-file-content")
  for (const textarea of textareas) {
    const textareaElement = $(textarea)
    textareaElement.scrollTop(textarea.scrollHeight)
  }
})
